import React, { useEffect, useRef, useState } from 'react'
import styles from './Count.module.scss'

const Count = (props: any) => {
  const ref = useRef<HTMLDivElement>(null)
  const [display, setDisplay] = useState<string>('0')

  useEffect(() => {
    const value = String(props.value)
    const match = value.match(/^(\d+)(.*)$/)

    if (!match) {
      setDisplay(value)
      return
    }

    const target = parseInt(match[1], 10)
    const suffix = match[2]
    const node = ref.current

    if (!node) {
      setDisplay(value)
      return
    }

    let frame = 0
    let started = false

    const animate = () => {
      const duration = 1400
      const start = performance.now()

      const tick = (now: number) => {
        const progress = Math.min((now - start) / duration, 1)
        const eased = 1 - Math.pow(1 - progress, 3)
        setDisplay(`${Math.round(target * eased)}${suffix}`)

        if (progress < 1) {
          frame = requestAnimationFrame(tick)
        }
      }

      frame = requestAnimationFrame(tick)
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !started) {
            started = true
            animate()
          }
        })
      },
      { threshold: 0.4 }
    )

    observer.observe(node)

    return () => {
      observer.disconnect()
      cancelAnimationFrame(frame)
    }
  }, [props.value])

  return (
    <div ref={ref} className={styles['count-wrapper']}>
      <p className={styles['count-value']}>{display}</p>
      <p className={styles['count-text']}>{props.text}</p>
    </div>
  )
}

export default Count
